import type { GetStaticProps, NextPage } from 'next'
import React, { useEffect } from 'react';
import { MetaTagsComp } from '../components/MetaTagsComp';
import BlogsLanding from '../components/BlogsLanding';
import fetchUtil from '../utils/fetchUtil';
import { commonJotformScript } from '../utils/constants';

const BlogsPage: NextPage = (props: any) => {
  const { meta } = props.pageData
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#6C48F0');
    customStyle.setProperty('--navbar-menu-color', '#ffff')
  }, [])

  const updatedMeta = meta?.jotforms?.length === 0
    ? { ...meta, jotforms: commonJotformScript }
    : { ...meta }

  return (
    <>
      {updatedMeta && <MetaTagsComp  {...updatedMeta} />}
      <BlogsLanding {...props} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/blogs-landing`, 'GET', {}, '', false)
  return {
    props: {
      pageData,
    }
  };
}

export default BlogsPage;